import React from 'react';

import classNames from 'classnames';

import { RDS_ICON } from '../Icon';

const SystemArrowRight = React.forwardRef<
  HTMLSpanElement, // The reference type - which element the final ref is attached to.
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...spanProps }, forwardedRef) => {
  // System Icons are size 16 only
  const iconClasses = classNames(RDS_ICON, `${RDS_ICON}-16`, className);

  // Spans are used here for sizing the SVG and to keep in line with the current styles
  // TODO: explore decoupling the svg itself from the outer contents: https://jira.rallyhealth.com/browse/UCRON-1455
  return (
    <span ref={forwardedRef} {...spanProps} className={iconClasses}>
      <span>
        <svg
          focusable="false"
          height="16"
          role="presentation"
          viewBox="0 0 16 16"
          width="16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            clipRule="evenodd"
            d="M6.984.21L6.89.293a1.001 1.001 0 00-.084 1.32l.083.096 5.269 5.288H1A1 1 0 001 9h11.168l-5.28 5.3a1.003 1.003 0 001.32 1.5l.095-.084L16 8l-1.271-1.27L8.303.293A1 1 0 006.984.21z"
            fillRule="evenodd"
          />
        </svg>
      </span>
    </span>
  );
});

export default SystemArrowRight;
